---
id: go-shared-middleware
title: Shared middleware
owner: Backend Team
status: Active
lastReviewed: 2026-01-30
visibility: internal
tags:
  - middleware
  - auth
  - shared
---

## Product Overview

### Who it serves

This shared package provides common Gin middleware used across Go microservices for authentication, CORS handling, and standardized error responses.

### Primary workflow

Services attach the middleware to their Gin routers to validate Firebase tokens, enforce enterprise access rules, and normalize error output.

### Business rules

Requests must present valid Firebase ID tokens where required, enterprise access is verified through db-api, and error responses are wrapped into a consistent JSON structure.

### Outcomes

Services expose consistent authentication behavior and error response shapes across internal APIs.

### Out of scope

Service-specific authorization logic and request handling remain within each microservice.

## Technical Overview

### Architecture flow

Authentication middleware validates Firebase tokens, enriches Gin context with user claims, and gates access based on enterprise roles, while error middleware transforms errors into structured responses.

### Entry points

Key entry points include `ValidateFirebaseIDToken`, `ValidateEnterpriseUser`, `ValidateEnterpriseReziAdminUser`, and `ValidateEnterpriseAdminUser` in `apps/micro-services/go-shared/middleware/auth.go`, plus `CORS` in `cors.go` and `ErrorHanlder` in `error.go`.

### Key modules

`auth.go` encapsulates token validation and role checks, `cors.go` sets shared CORS headers, and `error.go` maps errors to JSON responses with `ReziError`.

### Data sources and sinks

Authentication uses Firebase token claims and calls the db-api to validate enterprise users.

### Integrations and side effects

The middleware integrates with Firebase Auth, db-api for enterprise validation, and writes error responses directly to the HTTP response.

### Constraints and risks

Missing or misconfigured Firebase credentials will cause auth failures, and incorrect db-api access can block enterprise routes.

## Changelog

- 2026-02-03: Can have custom token
- 2026-01-30: Initial documentation.
